import { clsx } from 'clsx';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from './Input.module.css';

export type InputFieldProps = ComponentPropsWithRef<'div'> & {
  className?: string;
  children?: ReactNode;
};

export const InputField = ({
  children,
  className,
  ...attrs
}: InputFieldProps) => {
  return (
    <div className={clsx(s.field, className)} {...attrs}>
      {children}
    </div>
  );
};
